export const config = {
    appname: 'Bioderma',
    client_id: '1269055400136680', // App ID
    facebook_app_id: '1269055400136680', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'apibdm2',
    agency_id: '',
    bzbsUrl: 'https://apibdm2.buzzebees-uat.com',
    bzbsModuleUrl: 'https://biodermamodule.buzzebees-uat.com',
    bzbsAddItemFromList: 'https://shoppingcartmodule14.buzzebees-uat.com/',
    bzbsBlobUrl: '	https://cdn.buzzebees-uat.com/th',
    bzbsShoppingCartUrl: 'https://shoppingcartservice14.buzzebees-uat.com/',
    bzbAddItem: 'https://stgc.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://stgc.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://stw.buzzebees.com',
    bzbsPointExpire: 'https://stw.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '1655767597-Ogr7KRyK',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyD6iFUk7ZGzdhbVATrSAswJ8fXMynBxFQQ",
        authDomain: "bioderma-staging-4319b.firebaseapp.com",
        projectId: "bioderma-staging-4319b",
        storageBucket: "bioderma-staging-4319b.appspot.com",
        messagingSenderId: "547473778627",
        appId: "1:547473778627:web:20e112b26db715b7ddff76"
    },
};
